import { render, staticRenderFns } from "./TrandingVue.vue?vue&type=template&id=6a2cb4f4&"
import script from "./TrandingVue.vue?vue&type=script&lang=js&"
export * from "./TrandingVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports